import moment from 'moment-timezone';
import {
    ORDERS_COMPLETE_REQUEST,
    ORDERS_COMPLETE_RECEIVE,

    ORDERS_COMPLETE_SET_SORTING,
    ORDERS_COMPLETE_SET_FILTER_TIME,
    ORDERS_FIND_SET_FILTER_SEARCH
} from './actions';

import { ORDERS_HIDE_IN_LISTS } from './../orders/actions';

const filter = (state, action) => {
    switch (action.type) {
        case ORDERS_COMPLETE_SET_FILTER_TIME:
            return Object.assign({}, state, {
                time: action.value
            });
        case ORDERS_FIND_SET_FILTER_SEARCH:
            return Object.assign({}, state, {
                search: action.value
            });
        default:
            return state;
    }
};

const sorting = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_COMPLETE_SET_SORTING:
            return Object.assign({}, state, {
                field: action.value,
                isAsc: state.field === action.value ? !state.isAsc : true
            });
        default:
            return state;
    }
}

const ordersComplete = (state = {
    isFetching: false,
    didInvalidate: true,
    numbers: [],
    sorting: { field: 'created_at', isAsc: false },
    filter: { time: 'all', search: '' }
}, action) => {
    switch (action.type) {
        case ORDERS_HIDE_IN_LISTS:
            return Object.assign({}, state, {
                numbers: state.numbers.filter(number => number !== action.number)
            });
        case ORDERS_COMPLETE_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case ORDERS_COMPLETE_RECEIVE:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                updatedAt: moment(),
                numbers: action.numbers
            });
        case ORDERS_COMPLETE_SET_SORTING:
            return Object.assign({}, state, {
                sorting: sorting(state.sorting, action)
            });
        case ORDERS_COMPLETE_SET_FILTER_TIME:
        case ORDERS_FIND_SET_FILTER_SEARCH:
            return Object.assign({}, state, {
                filter: filter(state.filter, action)
            });
        default:
            return state;
    }
};

export default ordersComplete;


// WEBPACK FOOTER //
// ./src/store/ordersComplete/reducers.js